module.exports = __webpack_public_path__ + "static/media/thumb.da645130.png";